import React from 'react';

import ButtonFilled from '../../components/common/Buttons/ButtonFilled';

import { generateCSVData } from '../../utils/fileUtils';
import { downloadFileAsBlob } from '../../utils/file';

import { useCommonStore } from '../../stores/commonStore';

import { VisualQCStatus } from '../../utils/enums';
import { MimeType } from '../../utils/file/MimeType';
import { sendQCReport } from '../../utils/api/requestApi';
import { useAuthStore } from '../../stores/authStore';

const DownloadCSV = () => {
    const fsns = useCommonStore((state) => state.threeDLiveFsns);
    const requestId = useCommonStore((state) => state.currentRequestId);
    const activePartner = useAuthStore((state) => state.activePartner);

    const setToastMessage = useCommonStore((state) => state.setToastMessage);

    const csvData = generateCSVData(fsns);
    const completedFSNQCData = csvData?.filter((item) => item.visualQCStatus !== VisualQCStatus.PENDING);

    const shouldDisableDownloadCSV = !completedFSNQCData?.length;
    const pendingQC = (csvData?.length ?? 0) - (completedFSNQCData?.length ?? 0);

    const handleExportCSV = () => {
        const data = [['FSN Id', 'GuardRails Status', 'FitFor3DInPP Status', 'VisualQC Status', 'VisualQC Message', 'Model', 'GuardRails Message']];
        csvData?.forEach((it) => data.push([`${it.fsn},${it.guardRailsStatus},${it.fitFor3DInPP},${it.visualQCStatus},${it.visualQCMessage},${it.modelUrl},${it.guardRailsMessage}`]));
        downloadFileAsBlob(data?.join('\n'), 'scale3DExport.csv', MimeType.CSV);
    };

    const generatePayload = () => {
        const payload: Array<any> = [];
        csvData?.forEach((data) => payload.push({ productId: data.fsn, visualQCResult: data.visualQCStatus === 'PASSED' ? 'true' : 'false', guardrailsResult: data.guardRailsStatus.toString() }));
        return payload;
    };

    const triggerSendQCReport = async () => {
        try {
            const payload = generatePayload();
            const response = await sendQCReport(requestId, payload);
            setToastMessage({ type: 'success', message: 'Report Sent', description: 'Detailed report for status of each product sent successfully' });

            // if(response.data === '') {
            //     setToastMessage({ type: 'success', message: 'Report Sent', description: 'Detailed report for status of each product sent successfully' });
            // } else {
            //     setToastMessage({ type: 'error', message: 'Failed to Save Report', description: 'Something went wrong while sending report for this request' });
            // }
        } catch (e) {
            // setIsPendingRequest(false);
            setToastMessage({ type: 'error', message: 'Failed to Save Report', description: 'Something went wrong, check report data for details' });
            console.log('send report failed', e);
        }
    };

    return (
        <div className="flex flex-col p-5 gap-2" style={{ minHeight: 185 }}>
            {csvData?.length ? <p>Pending QC: {`${pendingQC} out of ${csvData.length}`}</p> : null}

            <ButtonFilled
                label="Download Report"
                onClick={() => {
                    activePartner !== 'flipkart' ? triggerSendQCReport() : handleExportCSV();
                }}
                fullWidth
            />
        </div>
    );
};

export default React.memo(DownloadCSV);
